export const GET_HOMEPAGE_FEED_START = 'GET_HOMEPAGE_FEED_START';
export const GET_HOMEPAGE_FEED_SUCCESS = 'GET_HOMEPAGE_FEED_SUCCESS';
export const GET_HOMEPAGE_FEED_FAIL = 'GET_HOMEPAGE_FEED_FAIL';



// WEBPACK FOOTER //
// ./src/features/homepage/redux/constants.js